// extracted by mini-css-extract-plugin
module.exports = {"container":"bigText_container__1SWUU","container__bigText":"bigText_container__bigText__2DZrD","fadeImage":"bigText_fadeImage__3A-js"};